
<div class="container mb-48r">
    <div class="row">
        <div class="col-10 offset-1 mb-5 typo_3">
            
            <ng-content></ng-content>

        </div>
    </div>
</div>